module.exports = __webpack_public_path__ + "img/Invoice.8efa0261.png";